import React from 'react';
import PropTypes from 'prop-types';
import { ShieldCheck } from 'lucide-react';
import styles from './badgeBase.module.scss';

const ICON_SIZE = 14;

const BadgeShieldCheck = ({
  variant = 'verified',
  className = '',
  size = ICON_SIZE,
  outline = true,
}) => {
  let variantClass = styles.iconVerified;
  if (variant === 'twineRecommends') {
    variantClass = outline
      ? styles.iconTwineRecommendsOnPill
      : styles.iconTwineRecommends;
  }

  return (
    <ShieldCheck
      size={size}
      strokeWidth={2}
      aria-hidden
      className={[
        styles.icon,
        variantClass,
        variant === 'verified' && !outline
          ? styles.iconVerifiedNoOutline
          : null,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ width: size, height: size }}
    />
  );
};

BadgeShieldCheck.propTypes = {
  variant: PropTypes.oneOf(['verified', 'twineRecommends']),
  className: PropTypes.string,
  size: PropTypes.number,
  outline: PropTypes.bool,
};

export default BadgeShieldCheck;
